var _circle, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8WearApron50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30,15c0-4,0-5,0-5h-2v5h-8v-5h-2c0,0,0,1,0,5c0,5-3,5-3,5v18h18V20C33,20,30,20,30,15z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 2,
    x: 9,
    y: 24,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8WearApron50);
export default __webpack_public_path__ + "static/media/icons8-wear-apron-50.372e3529e70e8447dd389bbc335928d5.svg";
export { ForwardRef as ReactComponent };